import { render, staticRenderFns } from "./ImageSelectCategory.vue?vue&type=template&id=b3bdd846&scoped=true"
import script from "./ImageSelectCategory.vue?vue&type=script&lang=js"
export * from "./ImageSelectCategory.vue?vue&type=script&lang=js"
import style0 from "./ImageSelectCategory.vue?vue&type=style&index=0&id=b3bdd846&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bdd846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3bdd846')) {
      api.createRecord('b3bdd846', component.options)
    } else {
      api.reload('b3bdd846', component.options)
    }
    module.hot.accept("./ImageSelectCategory.vue?vue&type=template&id=b3bdd846&scoped=true", function () {
      api.rerender('b3bdd846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageSelect/ImageSelectCategory.vue"
export default component.exports